// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Alert } from '@op/opds.opux';
import message from '../messages';
import { returnLink } from '../Constants';

const ErrorPage: React.FC = () => {
    return (
        <div id="errorPage" className="opux-align-center opux-spacing-top-margin-double" data-testid="error-page">
            <Alert type="critical" data-testid="alert">
                <h1 className="opux-spacing-top-margin-half" data-testid="error-header">
                    {message('error_header')}
                </h1>
                <h3 className="opux-spacing-top-margin opux-spacing-bottom-margin" data-testid="error-body">
                    {message('error_body')}
                </h3>
            </Alert>
            <div className="opux-spacing-top-margin-double opux-align-center" data-testid="return-link-container">
                <h3>
                    <a href={returnLink} className="opux-action-link" data-testid="return-link">
                        {message('linkToMainPage')}
                    </a>
                </h3>
            </div>
        </div>
    );
};

export default ErrorPage;
